import React from "react";

import styles from "./lineLoader.scss";

export default function LineLoader({ show }) {
  return (
    <div className={`${styles.loading} ${show ? "" : styles.hide}`}>
      <div className={styles.loadingBar}></div>
    </div>
  );
}
